/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PresenterAIAgentSettingResponse,
  PresenterError,
  PresenterResponse,
  PresenterUpdateAIAgentSettingRequest,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class AiAgentSettings<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Returns the current office's AI agent suggestion toggle state and consent flag.
   *
   * @tags ai_agent_settings
   * @name GetSettingsAiAgent
   * @summary Get the AI Agent setting
   * @request GET:/settings/ai-agent
   */
  getSettingsAiAgent = (params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterAIAgentSettingResponse;
      },
      PresenterError
    >({
      path: `/settings/ai-agent`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Enable or disable AI suggestion for the office. When enabling for the first time, `consent_agreed` must be true.
   *
   * @tags ai_agent_settings
   * @name PutSettingsAiAgent
   * @summary Toggle the AI Agent setting
   * @request PUT:/settings/ai-agent
   */
  putSettingsAiAgent = (
    body: PresenterUpdateAIAgentSettingRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterAIAgentSettingResponse;
      },
      PresenterError
    >({
      path: `/settings/ai-agent`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
